module.exports = new __parcel__URL__("github.30ecc23c.png").toString();